import React, { useState } from 'react';

import { 
  Switch, 
  FormControlLabel, 
  withStyles, 
  Tooltip
} from '@material-ui/core';

import { generatePointsTable } from './helpers/generate-points-table';
import { validateCalcForm } from './helpers/validate-calc-form';
import { calculatePoints } from './helpers/calculate-points';
import { PointsDisplayTable } from './components/points-display-table';
import { PlacesSelector } from './components/places-selector';
import { CalculatorRow } from './components/calculator-row';
import { PointsSwitch } from './components/points-switch';

import iconImage from './assets/images/info-icon.png';
import './styles/calculator.css';

const ExpandedSwitch = withStyles({
  switchBase: {
    color: '#ffc404 !important',
    '&$checked': {
      color: '#ffc404 !important',
    },
    '&$checked + $track': {
      backgroundColor: '#ffc404 !important',
    },
  },
  checked: {},
  track: {},
})(Switch);

const divisionPointTableIds = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  'Y': 5
};

const visibleOptionsDefaults = {
  divisions: false,
  goRounds: false,
  longRounds: false,
  finals: false,
  aggregated: false,
};

const calcParamsDefault = {
  division: null,
  goRounds: 0,
  longRoundsPlaces: 0,
  finalsPlaces: 0,
  aggregatePlaces: 0,
};

const transpose = t => t[0].map((c, i) => t.map(r => r[i]));

export const Calculator = () => {
  const [numberOfGoRounds, setNumberOfGoRounds] = useState();
  const [includeFinalsPoints, setIncludeFinalsPoints] = useState(false);
  const [includeAggregatePoints, setIncludeAggregatePoints] = useState(false);
  const [visibleOptions, setVisibleOptions] = useState(visibleOptionsDefaults);
  const [calcParams, setCalcParams] = useState(calcParamsDefault);
  // const [displayHeaders, setDisplayHeaders] = useState([]);
  const [displayTable, setDisplayTable] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [expandedPoints, setExpandedPoints] = useState(false);
  const [maxAllowedPlaces, setMaxAllowedPlaces] = useState(10);

  const setParams = (type, places) => {
    setCalcParams({...calcParams, [type]: places,});
    setDisplayTable([]);
    setVisibleOptions(visibleOptionsDefaults);
    if (type == 'division') {
      if (places == 5 || places == 'Y') {
        setExpandedPoints(false);
        setMaxAllowedPlaces(10);
        setCalcParams({
          ...calcParams, 
          [type]: places,
          longRoundsPlaces: 0,
          finalsPlaces: 0,
          aggregatePlaces: 0
        });
      } else if (expandedPoints) {
        setMaxAllowedPlaces(20);
      }
    } 
  };

  const toggleShowOptions = (option?) => {
    const options = option ? {...visibleOptions, [option]: !visibleOptions[option]} : visibleOptionsDefaults;
    setVisibleOptions(options);
  }; 

  const setIncludeFinals = (val) => {
    setIncludeFinalsPoints(val);
    setDisplayTable([]);
    val === false && setCalcParams({...calcParams, finalsPlaces: 0});
  };

  const setIncludeAggregated = (val) => {
    setIncludeAggregatePoints(val);
    setDisplayTable([]);
    val === false && setCalcParams({...calcParams, aggregatePlaces: 0});
  };

  const handleExpandedPoints = (division?) => {
    const divisionId = division ? division : calcParams.division;
    if (expandedPoints) {
      setMaxAllowedPlaces(10);
      setCalcParams({
        ...calcParams,
        longRoundsPlaces: 0, 
        finalsPlaces: 0,
        aggregatePlaces: 0
      });
    }

    !expandedPoints && divisionId == 5 && divisionId == 'Y' && setMaxAllowedPlaces(10);
    !expandedPoints && divisionId != 5 && divisionId != 'Y' && setMaxAllowedPlaces(20);

    setDisplayTable([]);
    setExpandedPoints(!expandedPoints);
  };

  const finalsDisabled = (
    calcParams.goRounds < 1
    // false
  );

  const aggregateEnabled = (
    calcParams.goRounds >= 2 ||
    calcParams.goRounds && includeFinalsPoints
  );

  const handleSubmit = () => {
    setSubmitted(true);
    setDisplayTable([]);
    const errorList = validateCalcForm(calcParams);

    setErrorMessages(errorList);
    if (errorList.length) {
      return;
    }
    const table = calculatePoints(calcParams, includeFinalsPoints, includeAggregatePoints);
    setDisplayTable(table);
  };

  return (
    <div className="wrapper">
      <div className="page-content">
        <div className="calculator-form">
          <h2 className="title">Calculate Points*
            {/* <Tooltip title={<span className="tooltip-text" >Exanded Points are disabled on Divisions 5 and Y</span>}>
              <FormControlLabel
                className="exp-points-switch"
                label="Expanded Points"
                disabled={calcParams.division == 5 || calcParams.division == 'Y'}
                control={
                    <ExpandedSwitch
                      checked={expandedPoints}
                      onChange={handleExpandedPoints}
                      name="expandedPoints"
                      color="primary"
                    />
                }
              /> 
            </Tooltip> */}
          </h2>
          <CalculatorRow>
            <div className="col 12 m7 s7">
              <label>WCRA Division Level Classification
                <span>
                  <a className="" target="_blank" href={`${window.location.href}/division-rankings-and-nomination-fees/`}>
                    Div. Levels? <img src={iconImage}/>
                  </a>
                </span>
              </label>
            </div>
            <div className="col 12 m5 s5">
              <ul className="list-unstyled division-level "
                  onClick={() => toggleShowOptions('divisions')} 
                  onBlur={() => toggleShowOptions('divisions')} >
                <li className="init" >
                    {calcParams.division ? `Division ${calcParams.division}` : `Please select`}
                </li>
                <li className="division-level ul-dropbox" style={{display: visibleOptions.divisions && 'list-item'}}>
                  <ul>
                    {Object.keys(divisionPointTableIds).map((id, index) => (
                      <li key={index}
                        className={`division-level-value ${calcParams.division === id && 'selected'}`} 
                        onClick={() => setParams('division', id)} >
                          Division {id}
                      </li>
                    ))}
                    <li className="for-mobile">
                      <a className="" target="_blank" href={`${window.location.href}/division-rankings-and-nomination-fees/`}>
                        What is it? <img src={iconImage}/> 
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </CalculatorRow>
          <CalculatorRow>
              <PlacesSelector 
                label="Total Long Go Rounds" 
                selectType="goRounds" 
                param={calcParams.goRounds} 
                action={setParams} 
                itemLimit={10}
              />
          </CalculatorRow>
          <CalculatorRow>
              <PlacesSelector 
                label="Places Paid/Long Round" 
                selectType="longRoundsPlaces" 
                param={calcParams.longRoundsPlaces} 
                disabled={!calcParams.goRounds}
                action={setParams} 
                itemLimit={maxAllowedPlaces} />
          </CalculatorRow>
          <CalculatorRow>
              <PointsSwitch 
                label="Finals"
                name='final'
                tooltip={'Please select at least 1 Go Round and 1 Places Paid/Long Round'}
                disabled={finalsDisabled}
                included={includeFinalsPoints}
                action={setIncludeFinals} />
          </CalculatorRow>
          <CalculatorRow visibleClass={includeFinalsPoints ? 'show-row' : 'hide-row'}>
              <PlacesSelector 
                label="Places Paid/ Final" 
                selectType="finalsPlaces" 
                disabled={!includeFinalsPoints || finalsDisabled}
                param={calcParams.finalsPlaces} 
                action={setParams} 
                itemLimit={maxAllowedPlaces} />
          </CalculatorRow>
          <CalculatorRow>
              <PointsSwitch 
                label="Aggregate (Average)"
                name='agg'
                tooltip="Please select at Least 2 Go Rounds and 1 Places Paid/Long Round or 1 Go Round and 1 Places Paid/Long Round and 1 Places Paid/Finals"
                disabled={!aggregateEnabled}
                included={includeAggregatePoints}
                action={setIncludeAggregated} />
          </CalculatorRow>
          <CalculatorRow visibleClass={includeAggregatePoints ? 'show-row' : 'hide-row'}>
              <PlacesSelector 
                label="Places Paid/ Aggregate" 
                selectType="aggregatePlaces" 
                disabled={!includeAggregatePoints || !aggregateEnabled}
                param={calcParams.aggregatePlaces} 
                action={setParams} 
                itemLimit={maxAllowedPlaces} />
          </CalculatorRow>
          <CalculatorRow>
              <div className="col 12 m12">
                <div className="calculatebutton button" onClick={handleSubmit}>Calculate</div>
                {errorMessages.map((message, i) => (
                  <p className="err-message" style={{color: 'red'}} key={i}>{message}</p>
                ))}
              </div>
          </CalculatorRow>  
        </div>
        { displayTable.length > 0 && <PointsDisplayTable calcParams={calcParams} displayTable={displayTable} /> }
      </div>
    </div>
  );
};